import styled from 'styled-components';

import * as MUIIcon from '@mui/icons-material';

export const MenuIcon = styled(MUIIcon.Menu)``;
